/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Price_Includes_Material_TextInputs */

const vi_product_price_includes_material_text = /** @type {(inputs: Product_Price_Includes_Material_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá sản phẩm đã gồm giá vật tư`)
};

/**

* @param {Product_Price_Includes_Material_TextInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_price_includes_material_text = /** @type {((inputs?: Product_Price_Includes_Material_TextInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Price_Includes_Material_TextInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_price_includes_material_text(inputs)
});